export default __webpack_public_path__ + "static/marcrmcase2-a7ca5b17042dfd8f28b405be812c4732.png";